export const animationFrameInterval = (handler: FrameRequestCallback): (() => void) => {
  let requestId: number

  const wrappedHandler: FrameRequestCallback = (...payload) => {
    handler(...payload)
    requestId = window.requestAnimationFrame(wrappedHandler)
  }

  requestId = window.requestAnimationFrame(wrappedHandler)

  return () => window.cancelAnimationFrame(requestId)
}
